module.exports = __webpack_public_path__ + "static/media/users-cog.db3e14ea.svg";